var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const Svg404 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 170,
  height: 84,
  fill: "none",
  viewBox: "0 0 170 84"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F9E193",
  d: "m29.597 2.998 18.726 11.575-28.67 46.383L.926 49.38z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9E193",
  d: "M28.981 44.684h22.128V84H28.981z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#A5E2B6",
  d: "M118.893 50.108C118.893 68.826 103.719 84 85.001 84c-18.719 0-33.893-15.174-33.893-33.892 0-18.718 15.174-33.892 33.893-33.892 18.718 0 33.892 15.174 33.892 33.892Zm-49.288 0c0 8.503 6.892 15.396 15.395 15.396s15.396-6.893 15.396-15.396-6.893-15.396-15.395-15.396c-8.504 0-15.397 6.893-15.397 15.396Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1E8FD",
  d: "m147.563 2.998 18.726 11.575-28.67 46.382-18.727-11.575z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1E8FD",
  d: "M146.946 44.684h22.128V84h-22.128z"
})));
export default Svg404;